var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMegaphone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 8 16 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 20.9v-3.021l3 .643V20.9zM21 9v.191L7.79 12.022A1 1 0 0 0 7 13v3c0 .471.329.879.79.977l2.21.474V22c0 .552.447.9 1 .9h5c.553 0 1-.348 1-.9v-3.049l4 .857V20a1 1 0 1 0 2 0V9a1 1 0 1 0-2 0"
})));
export default SvgMegaphone;